
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plasmids/[setID]",
      function () {
        return require("private-next-pages/plasmids/[setID]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plasmids/[setID]"])
      });
    }
  